/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Source_DescInputs */

const en_wc_dl_source_desc = /** @type {(inputs: Wc_Dl_Source_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developers can build WordCraft with Rust 1.90 or newer:`)
};

/**
* | output |
* | --- |
* | "Developers can build WordCraft with Rust 1.90 or newer:" |
*
* @param {Wc_Dl_Source_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_source_desc = /** @type {((inputs?: Wc_Dl_Source_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Source_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_source_desc(inputs)
});
export { wc_dl_source_desc as "wc.dl.source_desc" }